<template>
  <div class="search-layout">
    <div id="lbs-header" />
    <nuxt />
    <div id="lbs-footer" />
  </div>
</template>
<script>
export default {
  head() {
    return {
      meta: [
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=Edge,chrome=1' },
        { 'http-equiv': 'X-UA-Compatible', content: 'edge' },
        { name: 'viewport', content: 'width=1440' }
      ],
      link: [
        { rel: 'icon', type: 'image/x-icon', href: 'https://mapapi.qq.com/web/lbs/logo/favicon.ico' }
      ]
    };
  },
};
</script>
<style lang="less">
.search-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  .page-main {
    flex-grow: 1;
  }
  #lbs-footer {
    background-color: #f3f8fd;
  }
}
</style>
